<section class="record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span>{{'setAssignedToLog.to'|translate}}
    </span>
</section>
<section class="details" c-toggle="showDetails">
    <section class="recipients-section">
        <span>{{'setAssignedToLog.recipients'|translate}}:</span>
        <ul>
            <li class="user" ng-repeat="user in activity.AssignedTo track by $index">{{user.DisplayName}}&nbsp;({{user.UserName}})</li>
        </ul>
        <div c-activity-log-message activity="activity"></div>
    </section>
</section>
